import { Project } from '../types';

const project: Project = {
  slug: 'the-office',
  accessPin: '1023',
  qrTickets: ['A8F3K2'],
  info: {
    id: 1,
    title: 'The Office',
    category: {
      'en-US': 'Commercial',
      'es-MX': 'Comercial',
    },
    year: 2025,
    location: 'Los Cabos, Baja California Sur',
    floor: '2 floors',
    building: '1,270.34aZA-',
    cover: '/images/Cover3.webp',
    description: {
      'en-US':
        "This two-level restaurant is envisioned as a contemporary coastal retreat, where exposed wood, pitched roofs, and an open structural language evoke a refined tropical aesthetic. The central A-frame volume creates a strong visual axis, organizing the interior spaces with symmetry and hierarchy. The design emphasizes openness to the sea, with upper and lower terraces that fully embrace the view and natural ventilation. Sculptural pendant lighting adds warmth and character at night, while natural materials reinforce the project's connection to its surroundings.",
      'es-MX':
        'Este restaurante de dos niveles se concibe como un refugio costero contemporaneo, donde la madera expuesta, los techos inclinados y una estructura abierta evocan una estetica tropical refinada. El volumen central en forma de A crea un eje visual fuerte que organiza los espacios interiores con simetria y jerarquia. El diseno enfatiza la apertura hacia el mar, con terrazas superior e inferior que aprovechan la vista y la ventilacion natural. La iluminacion colgante escultorica aporta calidez y caracter por la noche, mientras los materiales naturales refuerzan la conexion del proyecto con su entorno.',
    },
  },
  assets: {
    images: [
      { file: '3.1', ext: 'webp' },
      { file: '3.2', ext: 'webp' },
      { file: '3.3', ext: 'webp' },
      { file: '3.4', ext: 'webp' },
      { file: '3.5', ext: 'webp' },
      { file: '3.6', ext: 'webp' },
      { file: '3.7', ext: 'webp' },
    ],
    videos: [],
    panos: [],
  },
};

export default project;
